import React from 'react';
import { Box, Typography } from '@mui/material';

import ParticipantItem from '../ParticipantItem';

import { IParticipantList } from './interfaces';

import { useStyles } from './styles';

const ParticipantList = ({
  name,
  participants,
  currentParticipantId,
  isOffline = false,
  onClose,
}: IParticipantList) => {
  const classes = useStyles(isOffline);

  return (
    <>
      {name && (
        <Box sx={classes.group}>
          <Typography sx={classes.groupName}>{name}</Typography>
        </Box>
      )}
      <Box sx={classes.list}>
        {participants.map((participant) => (
          <ParticipantItem
            key={participant.participantId}
            participant={participant}
            currentParticipantId={currentParticipantId}
            onClose={onClose}
          />
        ))}
      </Box>
    </>
  );
};

export default ParticipantList;
